import { useFonts } from 'expo-font';
import { FontFamilyName } from 'smoothie';

import FigtreeVariableItalic from '../../../assets/fonts/figtree/Figtree-Italic-Variable.ttf';
import FigtreeVariable from '../../../assets/fonts/figtree/Figtree-Variable.ttf';
import IosevkaExtendedMedium from '../../../assets/fonts/iosevka/IosevkaCustom-ExtendedMedium-Latin.woff2';
import IosevkaExtendedSemiBold from '../../../assets/fonts/iosevka/IosevkaCustom-ExtendedSemiBold-Latin.woff2';
import SourceSerifBold from '../../../assets/fonts/source_serif/SourceSerif4-Bold.woff2';
import SourceSerifItalic from '../../../assets/fonts/source_serif/SourceSerif4-Italic.woff2';
import SourceSerifRegular from '../../../assets/fonts/source_serif/SourceSerif4-Regular.woff2';
import SourceSerifSemiBold from '../../../assets/fonts/source_serif/SourceSerif4-SemiBold.woff2';
import type { CustomFontsLoader } from '../types/Fonts';

// expo-font's useFonts always registers @font-face with font-style: normal regardless of
// the font name used. To support italic, we must inject a separate @font-face rule under
// the same family name (Figtree-Variable) but with font-style: italic so the browser can
// match it when components apply fontStyle="italic".
const italicFontFaceStyle = document.createElement('style');
// Metro resolves .ttf to a string URL on web; satisfy no-base-to-string for the CSS url() value
const figtreeItalicFontUrl = String(FigtreeVariableItalic);
italicFontFaceStyle.textContent = `
    @font-face {
        font-family: '${FontFamilyName.FigtreeVariable}';
        src: url('${figtreeItalicFontUrl}') format('truetype');
        font-style: italic;
        font-weight: 100 900;
    }
`;
document.head.appendChild(italicFontFaceStyle);

export const useCustomFonts = (): CustomFontsLoader => {
    const [fontsLoaded, fontLoadingError] = useFonts({
        [FontFamilyName.FigtreeVariable]: FigtreeVariable,
        [FontFamilyName.IosevkaExtendedMedium]: IosevkaExtendedMedium,
        [FontFamilyName.IosevkaExtendedSemiBold]: IosevkaExtendedSemiBold,
        [FontFamilyName.SourceSerifRegular]: SourceSerifRegular,
        [FontFamilyName.SourceSerifSemiBold]: SourceSerifSemiBold,
        [FontFamilyName.SourceSerifBold]: SourceSerifBold,
        [FontFamilyName.SourceSerifItalic]: SourceSerifItalic,
    });

    return [fontsLoaded, fontLoadingError];
};
